export var CANDIDATE_PROFILE_EVENTS = {
    SHOW_LOGIN_MODAL: "CANDIDATE_PROFILE_SHOW_LOGIN_MODAL",
    HIDE_LOGIN_MODAL: "CANDIDATE_PROFILE_HIDE_LOGIN_MODAL",
    SHOW_REGISTRATION_MODAL: "CANDIDATE_PROFILE_SHOW_REGISTRATION_MODAL",
    HIDE_REGISTRATION_MODAL: "CANDIDATE_PROFILE_HIDE_REGISTRATION_MODAL",
    SHOW_RESETPASSWORD_MODAL: "CANDIDATE_PROFILE_SHOW_RESETPASSWORD_MODAL",
    HIDE_RESETPASSWORD_MODAL: "CANDIDATE_PROFILE_HIDE_RESETPASSWORD_MODAL",
    SHOW_FULLSCREEN_RLA_MODAL: "CANDIDATE_PROFILE_SHOW_FULLSCREEN_RLA_MODAL",
    HIDE_FULLSCREEN_RLA_MODAL: "CANDIDATE_PROFILE_HIDE_FULLSCREEN_RLA_MODAL",
    SHOW_REGISTRATION_SUCCESS: "CANDIDATE_PROFILE_SHOW_REGISTRATION_SUCCESS_MODAL",
    HIDE_REGISTRATION_SUCCESS: "CANDIDATE_PROFILE_HIDE_REGISTRATION_SUCCESS_MODAL",
    SHOW_TWO_STEP_MODAL: "CANDIDATE_PROFILE_SHOW_TWO_STEP_MODAL",
    HIDE_TWO_STEP_MODAL: "CANDIDATE_PROFILE_HIDE_TWO_STEP_MODAL",
    SHOW_LINKEDIN_IMPORT_PROFILE_MODAL: "CANDIDATE_PROFILE_SHOW_LINKEDIN_IMPORT_PROFILE_MODAL",
    HIDE_LINKEDIN_IMPORT_PROFILE_MODAL: "CANDIDATE_PROFILE_HIDE_LINKEDIN_IMPORT_PROFILE_MODAL",
    LINKEDIN_IMPORT_PROFILE_MODAL_CLOSED_ON_JOB_AD: "LINKEDIN_IMPORT_PROFILE_MODAL_CLOSED",
};
export var HEADER = {
    HEADER_CONTAINER_RENDERED: "HEADER_CONTAINER_RENDERED",
    HEADER_SEARCH_TOGGLE: "HEADER_SEARCH_TOGGLE",
};
export var RECRUITER_SPACE_EVENTS = {
    HEADER_CONFIG_CHANGE: "RECRUITER_SPACE_HEADER_CONFIG_CHANGE",
};
//# sourceMappingURL=harmonised-header.js.map